<template>
  <v-flex xs12 md12 class="mt-0 mb-0 pb-0 mx-0 mx-0">
    <h1 class="py-md-6 px-3 pb-0 mb-0">{{ $t("common.settings") }}</h1>
    <v-card class="mx-3" elevation="0">
      <v-card-actions>
        <v-tabs
            class="rounded light-shadow"
            show-arrows
            v-model="generalTabIndex"
        >
          <v-tab
              v-for="gTab in filteredGeneralTabs"
              :key="gTab.index"
              append
          >
            {{ $t(gTab.title) }}
          </v-tab>
        </v-tabs>
      </v-card-actions>
      <v-card-actions v-show="filterdTabs.length>1">
        <v-tabs
            v-show="!isAuthInProcess"
            class="rounded light-shadow"
            show-arrows
            v-model="tabIndex"
        >
          <v-tab
              v-for="tab in filterdTabs"
              :to="{ path: tab.path }"
              :key="tab.path"
              append
              v-show="!tab.right || (tab.right == 'view' && canUserViewConfig) || userHasRight(tab.right)"
          >
            {{ $t(tab.title) }}
          </v-tab>
        </v-tabs>
      </v-card-actions>
    </v-card>
    <v-card class="mx-3 mt-2" elevation="0" :loading="isAuthInProcess">
      <v-card-text>
      <router-view v-show="!isAuthInProcess"></router-view>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import RightsMixin from "@/mixins/rights";
export default {
  props: {},
  mixins: [RightsMixin],
  data: () => ({
    generalTabIndex:1,
    generalTabs:[
      {
        //Компания
        title: "viewSettings.tarrifplans.title",
        type: "tarrifplans",
        index: 0,
      },
      {
        //Компания
        title: "viewSettings.company.title",
        type: "company",
        index: 1,
      },
      {
        //Основные
        title: "viewSettings.general.title",
        type: "general",
        index: 2,
      },
      {
        //Интеграции
        title: "viewSettings.integrations.title",
        type: "integrations",
        index: 3,
      },

    ],
    tabIndex: 0,
    tabs: [
      {
        title: "viewSettings.company_details.title",
        path: "/settings",
        showAlways: true,
        generalTab: "company"
      },
      {
        title: "viewSettings.shop_payment_details.title",
        path: "/settings/bank-requisites",
        availableOnlyInLang: "ru",
        generalTab: "company"
      },
      {
        title: "viewSettings.tarrifplans.title",
        path: "/settings/tarrifplans",
        showAlways: true,
        generalTab: "tarrifplans"
      },
      {
        title: "viewSettings.shop_payment_details.title",
        path: "/settings/shop_payment_details",
        right: "view",
      },
      {
        title: "viewSettings.working_hours.title",
        path: "/settings/working_hours",
        right: "view",
        generalTab: "general"
      },
      {
        title: "navigation.users",
        path: "/settings/users",
        right: 'users|view',
        generalTab: "general"
      },
      {
        title: "navigation.users_roles",
        path: "/settings/user-roles",
        right: "view",
        generalTab: "general"
      },
      {
        title: "navigation.suppliers",
        path: "/settings/suppliers",
        right: 'suppliers|view',
        generalTab: "general"
      },


      {
        title: "navigation.aftermarket",
        path: "/settings/am",
        right: 'aftermarket|view',
        generalTab: "general"
      },
      {
        title: "navigation.sms_templates",
        path: "/settings/sms-templates",
        right: 'view',
        generalTab: "general"
      },
      {
        title: "navigation.goods_export",
        path: "/settings/goods-export",
        right: 'view',
        availableOnlyInLang: "ru",
        generalTab: "integrations"
      },
      {
        title: "viewSettings.statuses.title",
        path: "/settings/statuses",
        right: "view",
        generalTab: "general"
      },
      {
        title: "viewSettings.widget.title",
        path: "/settings/widget",
        right: "view",
        generalTab: "integrations"
      },
      {
        title: "viewSettings.order_stages.title",
        path: "/settings/order-stages",
        right: "view",
        generalTab: "general"
      },
      {
        title: "viewSettings.pricemarkups.title",
        path: "/settings/pricemarkups",
        right: "view",
        generalTab: "general"
      },
      {
        title: "viewSettings.prices_types.title",
        path: "/settings/prices-types",
        right: "view",
        generalTab: "general"
      },
      {
        title: "viewSettings.repairtime_types.title",
        path: "/settings/repairtime-types",
        right: "view",
        generalTab: "general"
      },
      {
        title: "viewSettings.repairtimetree.title",
        path: "/settings/repairtimetree",
        right: "view",
        generalTab: "general"
      },
      {
        title: "viewSettings.posts.title",
        path: "/settings/posts",
        right: "view",
        generalTab: "general"
      },
      {
        title: "viewSettings.diagnostics.title",
        path: "/settings/diagnostics",
        right: "view",
        generalTab: "general"
      },
      {
        title: "viewSettings.customer_sources.title",
        path: "/settings/customer-sources",
        right: "view",
        generalTab: "general"
      },
      {
        title: "viewSettings.customer_types.title",
        path: "/settings/customer-types",
        right: "view",
        generalTab: "general"
      },
      {
        title: "viewSettings.telephonies.title",
        path: "/settings/telephonies",
        right: "view",
        availableOnlyInLang: "ru",
        generalTab: "integrations"
      },
      {
        title: "viewSettings.sms_gateways.title",
        path: "/settings/sms-gateways",
        right: "view",
        generalTab: "integrations"
      },
      {
        title: "viewSettings.importExternalData.title",
        path: "/settings/import-external-data",
        right: "view",
        availableOnlyInLang: "ru",
        generalTab: "integrations"
      },
      {
        title: "viewSettings.APIAccess.title",
        path: "/settings/api-access",
        right: "view",
        generalTab: "integrations"
      },
      {
        title: "viewSettings.kkm.title",
        path: "/settings/kkm",
        right: "view",
        availableOnlyInLang: "ru",
        generalTab: "integrations"
      },
      {
        title: "navigation.shops",
        path: "/settings/shops",
        right: 'manage_shops',
        generalTab: "general"
      },
      {
        title: "viewSettings.personal.title",
        path: "/settings/personal",
        generalTab: "general"
      },
      {
        title: "viewSettings.navigation_menu.title",
        path: "/settings/navigation-menu",
        generalTab: "general"
      },
    ],
  }),
  mounted() {
    this.setGeneralTab()
  },
  watch:{
    $route(){
      this.setGeneralTab()
    },
    generalTabIndex(to, from){
      this.$nextTick(()=>{
        if(this.filterdTabs[0] && this.filterdTabs[0].path && this.filterdTabs[0].path!==this.$route.path) {
          this.$router.push({path: this.filterdTabs[0].path})
        }
        if(!this.filterdTabs[0]){
          this.filterdTabs=from;
        }
      })
    }
  },
  computed: {
    ...mapFields("auth", ["isAuthInProcess"]),
    ...mapFields("site", ["lang"]),
    currentGeneralTabType(){
      let currentGeneralTab = this.generalTabs.find(item=>item.index===this.generalTabIndex)
      return currentGeneralTab.type || "general";
    },
    filteredGeneralTabs() {
      return this.generalTabs.filter(item => {
        return this.allAvailableTabs.filter((tab) => {
          return tab.generalTab === item.type
        }).length
      })
    },
    filterdTabs() {
      if (!this.isHavingTarrifplan) {
        return this.tabs.filter((item) => item.showAlways && this.currentGeneralTabType===item.generalTab);
      } else {
        return this.tabs.filter((item)=>{
          return (!(item.availableOnlyInLang) || item.availableOnlyInLang && item.availableOnlyInLang===this.lang) && this.currentGeneralTabType===item.generalTab
        });
      }
    },
    allAvailableTabs() {
      if (!this.isHavingTarrifplan) {
        return this.tabs.filter((item) => item.showAlways);
      } else {
        return this.tabs.filter((item)=>{
          return (!(item.availableOnlyInLang) || item.availableOnlyInLang && item.availableOnlyInLang===this.lang)
        });
      }
    },
  },
  methods: {
    setGeneralTab(){
      let tab = this.tabs.find((item)=>item.path===this.$route.path)

      if(tab && tab.generalTab) {
        let generalTab = this.generalTabs.find(item=>item.type===tab.generalTab)
        this.generalTabIndex = generalTab.index;
      }
    }
  },
};
</script>

<style></style>
